"use client";

import React, { useCallback, useMemo, useRef } from "react";
import { LabelText } from "..";
import { globalStyleObj } from "@/app/assets/styles";
import dynamic from "next/dynamic";
import { editorOptions } from "@/app/assets/data/sun-editor-setting";
import { useTheme } from "next-themes";
import { createJoditConfig } from "@/config/jodit-editor.config";

const JoditEditor = dynamic(
  () => import("jodit-react"),
  { ssr: false } // This is key
);

const TextEditor = ({
  field,
  isItemDetailsExist = false,
  watchDescription,
  setValue,
}) => {
  const { theme } = useTheme();
  const editor = useRef(null);

  // Debounced change handler
  const handleChange = useCallback(
    (newContent) => {
      // Basic XSS prevention
      const cleanContent = newContent
        .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "")
        .replace(/javascript:/gi, "")
        .replace(/on\w+\s*=/gi, "");

      setValue(field.fieldName, cleanContent);
    },
    [field.fieldName, setValue]
  );

  return (
    <div
      className={`${field?.extraClasses || ""} ${globalStyleObj.commonInputContainerClass}`}
    >
      <LabelText
        text={field?.lableName || ""}
        htmlForId={`${isItemDetailsExist ? `update-${field.fieldId}` : field.fieldId}`}
        star={field?.labelStatus || false}
        translateField={field?.translateField || false}
      />

      <div className="w-full max-w-[800px] rounded-sm border border-[#000]/20 dark:border-[#fff]/10">
        <JoditEditor
          ref={editor}
          id={`${isItemDetailsExist ? `update-${field.fieldId}` : field.fieldId}`}
          value={watchDescription}
          name={field.fieldName}
          onChange={handleChange}
        />
      </div>
    </div>
  );
};

export default TextEditor;
